import { useCallback } from 'react';

export default function usePivot(gridRef) {
  return useCallback(() => {
    if (!gridRef.current.api.isPivotMode()) 
      gridRef.current.api.setPivotResultColumns(null);
  }, [])
}